import { useMemo } from 'react';
import { isRoleAdministrator } from '@/helpers/rfp';
/**
 * コンサルタント：案件メンバー一覧表示用に値を加工して返すuse
 * @param args
 */
export const useProfessionalRfpOfferMemberList = (args) => {
    const { professionalId, rfpOfferMembers, viewRequestProfessionalId } = args;
    return useMemo(() => {
        const values = rfpOfferMembers || [];
        const members = values.map((member) => ({
            email: member.email,
            firstName: member.first_name,
            id: member.id,
            involvement: member.involvement,
            isAdmin: isRoleAdministrator(member.role),
            // 自分と閲覧申請ユーザーは消せない
            isCanDelete: ![professionalId, viewRequestProfessionalId].includes(member.professional_id),
            // コンサルの場合は一覧から責任者は変更させない
            isShowAdminLabel: false,
            lastName: member.last_name,
            memberType: member.member_type,
            professionalId: member.professional_id,
            role: member.role,
            status: member.status,
        }));
        const member = values.find((value) => value.professional_id === professionalId);
        return {
            isMember: !!member,
            members,
        };
    }, [professionalId, rfpOfferMembers, viewRequestProfessionalId]);
};
